import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//comment create slice
export const permissionCreateOrUpdate = createAsyncThunk("userManagement/permissionCreateOrUpdate", async (body) => {
	try {
		const response = await axiosHttp.post(`permission/create`, body);
		return response.data;
	} catch (error) {
		message.error(error?.response?.data?.message || "Failed to assign permission");
		throw error;
	}
});

const userManagementPermissionCreateSlice = createSlice({
	name: "userManagementPermissionCreate",
	initialState: {
		isLoading: false,
		data: {},
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(permissionCreateOrUpdate.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(permissionCreateOrUpdate.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(permissionCreateOrUpdate.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default userManagementPermissionCreateSlice.reducer;
